import {themes} from "../../../styles/themes";
import {
  sortByKey,
  getPartidoInfo,
  getCamaraInfo,
  tooltipPartidoYDato,
  desfomatearPorcentaje,
  getLogo,
} from "../../../commons/js/util";
import "echarts/lib/component/tooltip";
import "echarts/lib/chart/bar";
import "echarts/lib/component/title";
import { position } from "../../../utils/tooltipPosition";
import { level, curulesEleccion, eleccion } from "../../../resources/constantes.json";

const seriesBaseOption = {
  type: "bar",
  stack: 'repartoVotos',
  name: 'votos'
};

const getSeries = (camara, nomenclator, t) => {
    const parsedData = [];
    const convocatoria = 'act';
    const partidos = camara.partotabla.filter(p => p['act'].pvot !== '0%');
    const sinInfo = camara.totales[convocatoria].pmesesc === '0%';

    if (sinInfo || partidos.length === 0) {
      parsedData.push(
        {
          ...seriesBaseOption,
          data:[
            {
              name: ( partidos.length === 0 ) ?  t("sinVotos") : t("sinInformacion"),
              value: 100,
              tipData: {
                showTooltip: true,
                sinInfo: true,
                noModal: true,
                color: themes.color.sinInfo,
              },
              itemStyle: {
                color: themes.color.sinInfo,
                borderColor: themes.color.sinInfo,
                shadowColor: themes.color.sinInfo,
                shadowBlur: 0,
                shadowOffsetY: 10,
                borderType: 'solid',
                opacity: 0.8
              },
              emphasis: {
                show: false,
                itemStyle: {
                  borderColor: themes.color.sinInfo,
                  color: themes.color.sinInfo,
                },
              },
            }
          ],
        }
      );
    } else {
      for (let index = 0; index < partidos.length; index++) {
          const partido = partidos[index]['act'];
          const par = getPartidoInfo(
              partido.codpar,
              nomenclator.partidos
          );
          
          parsedData.push({
              ...seriesBaseOption,
              data: [
                {
                  value: desfomatearPorcentaje(partido.pvot),
                  valueF: partido.pvot,
                  tipData: {
                    tipoCargo: t('votos'),
                    showTooltip: true,
                    codpar: par.codpar,
                    parName: par.nombre,
                    color: par.color,
                  },
                  itemStyle:{
                    color: par.color,
                    shadowColor:par.color,
                    shadowBlur: 0,
                    shadowOffsetY: 10,
                    borderType: 'solid',
                    opacity: 0.8
                  },
                },
              ],
              nombre: par.nombre,   
            });
      }
    }
    return parsedData;
};

export function getOption(camara, nomenclator, isSmall, isDesktop, t, lang) {
  const series = getSeries(camara, nomenclator, t);
  return {
    baseOption: {
      series: series,
      textStyle: {
        fontFamily: "Lato",
      },
      tooltip: {
        show: isDesktop,
        confine: true,
        padding: 0,
        // position: (point, params, dom, rect) => {
        //   return pos.current("top", rect, dom);
        // },
        formatter: function(params) {
          let result;
          const data = params.data;
          if (data && data.tipData?.showTooltip)
            if (!data.tipData.sinInfo)
              result = tooltipPartidoYDato(
                null,
                data.tipData.color ?? data.itemStyle.color,
                data.name,
                data.valueF,
                data.tipData.tipoCargo,
                null,
                null,
                null,
                null,
                getLogo(data.tipData.codpar, lang, data.tipData.convocatoria)
              );
            else
              result = tooltipPartidoYDato(
                null,
                data.itemStyle.color,
                data.name
              );
          return result;
        },
      },
      xAxis: {
        show: false,
        type: 'value',
        max: [desfomatearPorcentaje(camara.totales['act'].pvotcan)]
      },
      yAxis: {
        show: false,
        type: 'category',
      },
      grid: {
        left: isDesktop ? '5%' : '0%',
        right: '0',
        top: '5%',
        containLabel: false
      },
    },
  };
}